import axios, { AxiosError } from 'axios';

export const getDocTypes = async () => {
	try {
		const { data } = await axios.get<{
			doc_types: { title: string; value: string }[];
		}>(`${process.env.HOST}/api_v1/entities`);
		const { doc_types } = data;
		return doc_types;
	} catch (error) {
		if (error instanceof AxiosError) {
			console.log(error?.response?.data);
		} else {
			console.log(error);
		}
	}
};
